export const INTENT_TAXONOMY_VERSION = "2026-05-25.v1";

export type CustomerIntent =
  | "chat_now"
  | "kundali_report"
  | "marriage"
  | "career"
  | "health"
  | "finance"
  | "remedy_dosha"
  | "timing"
  | "low_intent"
  | "unknown";

export type IntentMatcher = {
  intent: CustomerIntent;
  terms: string[];
};

export const TEXT_INTENT_MATCHERS: IntentMatcher[] = [
  { intent: "marriage", terms: ["marriage", "match", "compatibility", "vivah", "shaadi"] },
  { intent: "career", terms: ["career", "job", "business", "profession"] },
  { intent: "health", terms: ["health", "disease", "medical"] },
  { intent: "finance", terms: ["finance", "money", "wealth", "loan"] },
  {
    intent: "remedy_dosha",
    terms: [
      "dosha",
      "dosh",
      "upay",
      "remedy",
      "puja",
      "shani",
      "saturn",
      "sade sati",
      "mangal",
      "manglik",
      "rahu",
      "ketu",
      "pitra",
      "kaal sarp",
    ],
  },
  {
    intent: "timing",
    terms: ["muhurat", "panchang", "choghadiya", "rahu kaal", "timing", "auspicious"],
  },
  { intent: "kundali_report", terms: ["kundali", "report", "pdf", "analysis", "forecast"] },
  { intent: "chat_now", terms: ["chat", "question", "answer", "consult", "astrologer"] },
  { intent: "low_intent", terms: ["free", "browse"] },
];

export const CHAT_LANDING_PATHS = new Set(["/ai-astrologer"]);
export const REPORT_LANDING_PATHS = new Set(["/free-kundali"]);
// quick_p99 = the retired session_price_pilot_2026_07 treatment SKU — the same
// 30-min session as quick at ₹99 (past buyers keep it), so it classifies
// identically wherever the SET of session plan ids matters (intentFromPlan →
// chat_now).
export const SESSION_PLAN_IDS = new Set(["quick", "quick_p99"]);

export const DOSHA_TEXT_MATCHERS: Array<{ doshaId: string; terms: string[] }> = [
  { doshaId: "shani_dosh", terms: ["shani", "saturn", "sade sati"] },
  { doshaId: "mangal_dosh", terms: ["mangal", "manglik", "mars"] },
  { doshaId: "kaal_sarp_dosh", terms: ["kaal sarp", "kaal-sarp"] },
  { doshaId: "pitra_dosh", terms: ["pitra", "pitru", "ancestor"] },
  { doshaId: "rahu_dosh", terms: ["rahu"] },
  { doshaId: "ketu_dosh", terms: ["ketu"] },
];

/**
 * Landing intents whose SEO surface sells a DEDICATED report (rule 40
 * never_bury). A seeker who ARRIVED on one of these surfaces stated their
 * intent explicitly, so the incidental chart dosha most kundalis carry must
 * not clobber it at ranking time (the 2026-06-09 career_report → ₹0 class —
 * career is not a dosha, so dosha-first routing made career unselectable).
 * CustomerIntent-taxonomy twin of DEDICATED_REPORT_PAGE_CATEGORIES in
 * post-kundali-cta.ts (the pageCategory side of the same policy) — keep the
 * career member aligned across both. `finance` maps to the career offer in
 * customer-intent.ts GOVERNED_OFFER_INTENT. `marriage` is intentionally NOT
 * here: the marriage report needs partner data, and matching surfaces gate it
 * separately (allowMarriageReport), so its landing intent must not suppress
 * dosha personalisation for single-person charts.
 */
export const DEDICATED_REPORT_LANDING_INTENTS: ReadonlySet<CustomerIntent> = new Set([
  "career",
  "finance",
]);
